import * as Sentry from '@sentry/nextjs'

export const setUser = (userId: string) => {
  Sentry.setUser({ id: userId })
}

export default Sentry
